import { render } from "./RankFooter.vue?vue&type=template&id=3f6fff22&scoped=true"
import script from "./RankFooter.vue?vue&type=script&lang=js"
export * from "./RankFooter.vue?vue&type=script&lang=js"

import "./RankFooter.vue?vue&type=style&index=0&id=3f6fff22&scoped=true&lang=scss"

import exportComponent from "/usr/share/nginx/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6fff22"]])

export default __exports__